module.exports = __webpack_public_path__ + "static/media/Outback_logo.e459b9c6.svg";